import styled, { css } from 'styled-components';

export type Tone = 'neutral' | 'success' | 'warning' | 'danger';

const toneStyles: Record<Tone, ReturnType<typeof css>> = {
  neutral: css`
    color: var(--stone-600);
    background: var(--stone-100);
  `,
  /* Texto nos tons escuros: sobre estes fundos pastel os tons vivos ficam
     lavados (o --feedback-danger dava 2,4:1). Assim ficam acima de 5:1. */
  success: css`
    color: var(--feedback-success-strong);
    background: #dcefe0;
  `,
  warning: css`
    color: var(--feedback-warning-strong);
    background: #fff2cc;
  `,
  danger: css`
    color: var(--feedback-danger-strong);
    background: #ffe0e1;
  `,
};

export const Wrapper = styled.span<{ tone: Tone }>`
  display: inline-flex;
  align-items: center;
  font-family: var(--font-sans);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  padding: 0.3rem 0.6rem;
  border-radius: var(--radius-full);
  letter-spacing: 0.01em;
  white-space: nowrap;

  ${(props: { tone: Tone }) => toneStyles[props.tone]}
`;
